import React from 'react';
import { Box } from '@mui/material';
import Notes from '../../pages/ServiceOrderPage/Notes';

export default function NotesTab({ order, stockNumber, setOrder }) {
  return (
    <Box>
      <Notes order={order} />
    </Box>
  );
}
